import { motion } from "framer-motion";
import { ChevronLeft, Sparkles } from "lucide-react";

const pageVariants = {
  initial: { opacity: 0, y: 20 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -20 }
};

export const ScanningScreen = ({ loadingStage, currentScanningMessage, resetApp }) => {
  return (
    <motion.div
      key="scanning"
      variants={pageVariants}
      initial="initial"
      animate="animate"
      exit="exit"
      className="min-h-screen flex flex-col items-center justify-center p-6 relative"
      data-testid="scanning-screen"
    >
      <button 
        onClick={resetApp}
        className="absolute top-6 left-6 w-10 h-10 rounded-full bg-white flex items-center justify-center border-2 border-[#264653]/10 hover:border-[#264653]/30"
        data-testid="scanning-back-btn"
      >
        <ChevronLeft className="w-5 h-5 text-[#264653]" />
      </button>

      <div className="relative">
        <div className="w-24 h-24 bg-[#FFB703]/20 rounded-full flex items-center justify-center loading-pulse">
          <Sparkles className="w-12 h-12 text-[#FFB703]" />
        </div>
        <div className="absolute inset-0 border-4 border-[#FFB703] border-t-transparent rounded-full animate-spin" />
      </div>
      <h2 className="text-2xl font-bold text-[#264653] mt-8">{loadingStage || "Scanning..."}</h2>
      
      <motion.p 
        key={currentScanningMessage}
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -10 }}
        className="text-[#264653]/70 mt-3 text-lg font-medium text-center"
      >
        {currentScanningMessage || "This may take a moment"}
      </motion.p>
      
      <div className="flex gap-2 mt-6">
        <div className="w-2 h-2 rounded-full bg-[#FFB703] animate-bounce" style={{ animationDelay: "0ms" }} />
        <div className="w-2 h-2 rounded-full bg-[#FFB703] animate-bounce" style={{ animationDelay: "150ms" }} />
        <div className="w-2 h-2 rounded-full bg-[#FFB703] animate-bounce" style={{ animationDelay: "300ms" }} />
      </div>
      
      <button 
        onClick={resetApp}
        className="mt-8 text-sm text-[#264653]/50 hover:text-[#264653]"
      >
        Cancel
      </button>
    </motion.div>
  );
};
